// import { initAlpine } from './alpine';

import './style.scss';

// import './blocks/accordion-details-summary/view.js';
// import './blocks/accordion-group/view.js';
import './blocks/query-taxonomy-filter/view.js';
import './blocks/query-filter-container/view.js';
// import './blocks/carousel/v2/GalleryCarousel/view.js';

console.log(`Front.js loaded v4, rollup`)
